'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GenericPlaceholder = function (_BcReactComponent) {
  _inherits(GenericPlaceholder, _BcReactComponent);

  function GenericPlaceholder(props) {
    _classCallCheck(this, GenericPlaceholder);

    var _this = _possibleConstructorReturn(this, (GenericPlaceholder.__proto__ || Object.getPrototypeOf(GenericPlaceholder)).call(this, props));

    _this.bindAll('validateImage', 'renderAnchorBib');
    _this.state = { showAnchorBibPlaceholder: true };
    return _this;
  }

  _createClass(GenericPlaceholder, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.validateImage(this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props.anchorBibSrc !== nextProps.anchorBibSrc) {
        this.setState({ showAnchorBibPlaceholder: true });
        this.validateImage(nextProps);
      }
    }
  }, {
    key: 'validateImage',
    value: function validateImage(newProps) {
      var _this2 = this;

      var src = newProps.anchorBibSrc;
      if (src) {
        var testImage = new Image();
        testImage.onload = function () {
          _this2.setState({
            showAnchorBibPlaceholder: testImage.width <= 1 || testImage.height <= 1
          });
        };
        testImage.src = src;
      }
    }
  }, {
    key: 'renderAnchorBib',
    value: function renderAnchorBib() {
      var anchorBibSrc = this.props.anchorBibSrc;

      if (this.state.showAnchorBibPlaceholder) {
        return null;
      }

      return _react2.default.createElement('image', {
        stroke: '#CCCCCC',
        strokeWidth: '1',
        xlinkHref: anchorBibSrc,
        x: '64',
        y: '61',
        width: '130',
        height: '100%',
        preserveAspectRatio: 'xMidYMin' });
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'svg',
        {
          className: 'cp-user-list-jacket-cover-generic-placeholder',
          focusable: 'false',
          'aria-hidden': 'true',
          viewBox: '0 0 232 275' },
        _react2.default.createElement(
          'g',
          { stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement(
            'g',
            { transform: 'translate(-24.000000, -15.000000)' },
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '24', y: '15', width: '72', height: '96' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '24', y: '211', width: '72', height: '76' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '24', y: '119', width: '72', height: '84' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '104', y: '15', width: '72', height: '79' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '104', y: '214', width: '72', height: '64' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '104', y: '102', width: '72', height: '104' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '184', y: '15', width: '72', height: '84' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '184', y: '209', width: '72', height: '81' }),
            _react2.default.createElement('rect', { fill: '#FFFFFF', x: '184', y: '107', width: '72', height: '94' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '26', y: '17', width: '68', height: '92' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '26', y: '213', width: '68', height: '72' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '26', y: '121', width: '68', height: '80' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '106', y: '17', width: '68', height: '75' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '106', y: '216', width: '68', height: '60' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '106', y: '104', width: '68', height: '100' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '186', y: '17', width: '68', height: '80' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '186', y: '211', width: '68', height: '77' }),
            _react2.default.createElement('rect', { fill: '#E5E5E5', x: '186', y: '109', width: '68', height: '90' })
          )
        )
      );
    }
  }]);

  return GenericPlaceholder;
}(_baseBcReactComponent2.default);

exports.default = GenericPlaceholder;


GenericPlaceholder.propTypes = {
  anchorBibSrc: _react.PropTypes.string
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-jacket-cover/components/GenericPlaceholder.component.js
// module id = 1310
// module chunks = 0